import React from 'react';
import './Badge.css';

export interface BadgeProps {
  variant?: 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';
  size?: 'sm' | 'md';
  dot?: boolean;
  children: React.ReactNode;
  className?: string;
}

export function Badge({ variant = 'primary', size = 'md', dot = false, children, className = '' }: BadgeProps) {
  return (
    <span className={`ui-badge ui-badge-${variant} ui-badge-${size} ${className}`}>
      {dot && <span className="ui-badge-dot" />}
      {children}
    </span>
  );
}
